import { mapState } from 'vuex';
import EbgSystemUsers from '@/components/ebgsystems/users/EbgSystemUsers.vue';
import TextEditor from '@ebg/vue-common/src/components/common/texteditor/TextEditor.vue';
import UserPicker from '@ebg/vue-common/src/components/user/picker/UserPicker.vue';

export default {
  name: 'EbgSystemUserGroups',
  props: {
    user: Object,
    groups: Object | Array,
    loading: Boolean
  },
  data () {
    return {
      tableItems: null,
      activeGroups: [], // user has group or has active request for group
      updatingUserGroups: false,
      selectedSystem: null,
      selectedSystemUserGroups: [],
      editSelectedSystemsTitle: null,
      autoApproveReq: false,
      itemSettings: {},
      isLoading: false,
      isUpdating: false,
      rowOpened: Boolean,
      userList: 'user/find?perPage=10&qry=Ed&isDisabled=0'
    }
  },
  components: {
    EbgSystemUsers,
    TextEditor,
    UserPicker
  },
  computed: {
    ...mapState(['config']),
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-user-system-groups') ||
            this.$session.get('user')?.is_head_user_or_manager ||
            this.user.ldapUsername === this.$session.get('ldapUsername'); // user can request groups for himself;
    },
    canViewSystemUsers () {
      return (this.ApiRequest.userHasPermission('view-company-users') ||
        this.ApiRequest.userHasPermission('view-all-users')) ||
        this.$session.get('user')?.is_head_user_or_manager;
    },
    tableHeaders () {
      const headers = [
        { key: 'title', label: this.$t('ebgsystem.title') },
        { key: 'groupbase', label: this.$t('ebgsystem.groupbase') },
        { key: 'description', label: this.$t('ebgsystem.description'), type: 'slot', slotcode: 'description' },
        { key: 'managers', label: this.$t('ebgsystem.managers'), type: 'slot', slotcode: 'managers' },
        { key: 'groups', label: this.$t('ebgsystem.groups'), type: 'slot', slotcode: 'groups' }
      ];
      const actions = [];
      if (this.canEdit) {
        actions.push({ label: this.$t('menu.user.ad-groups.edit'), emit: 'editItems', bicon: 'pencil-fill', class: 'btn-warning btn-sm' })
      }
      if (this.canViewSystemUsers) {
        actions.push({ label: this.$t('menu.user.ad-groups.list'), emit: 'viewList', bicon: 'list', class: 'btn-sm' })
      }
      if (actions.length > 0) {
        headers.push({ key: 'actions', label: '', class: 'text-end col-width-medium', actions: actions });
      }
      return headers;
    },
    systems () {
      return this.config.ebg_systems;
    },
    tableActions () {
      return { download: false, clearCache: true };
    }
  },
  methods: {
    updateUsers (id, user) {
      const managers = this.tableItems.find(el => el.id === id).managers;
      managers.push(user);
      this.$store.commit('toastAdd', { context: 'success', message: 'Atbildīgais pievienots' })
    },
    getTableData () {
      this.isLoading = true;
      this.currentReq = this.ApiRequest.request(`ad-groups/ebg-systems?user_api_id=${this.user.api_id}`, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          this.tableItems = response.data;
          this.tableItems.forEach(el => {
            this.$set(this.itemSettings, el.id, { showDescriptionEdit: false });
          });
          // this.paging = response.paging;
          this.isLoading = false;
        }
      });
    },
    save (id, description) {
      this.isUpdating = true;
      this.ApiRequest.request(`ad-groups/ebg-systems/${id}`, this.ApiRequest.REQUEST_PATCH, { id: id, description: description }, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.$store.commit('toastAdd', { context: 'success', message: 'Apraksts saglabāts!' })
          this.toggleDescription(id);
        }
        this.isUpdating = false;
      });
    },
    toggleDescription (id) {
      const el = this.itemSettings[id];
      this.rowOpened = !el.showDescriptionEdit;
      this.$set(el, 'showDescriptionEdit', !el.showDescriptionEdit);
    },
    closeModal (refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].hide();
      }
    },
    editItems (system) {
      this.selectedSystemUserGroups = [];
      this.selectedSystem = system;
      this.editSelectedSystemsTitle = this.$t('ebgsystem.editGroupsTitle', {
        username: this.user ? this.user.fullname : this.$session.get('name'),
        system: this.selectedSystem.title
      })
      const self = this;
      const activeRequestsId = this.$store.getters.getParamFromConfigByFilter('permission_request_statuses', 'code', 'OPEN', 'id');
      Object.values(this.selectedSystem.groups).forEach(el => {
        // self.selectedSystemUserGroups[el.code] = (system.activeGroups[el.id] && system.activeGroups[el.id].permission !== 'RW-REM');
        const hasActiveRequests = el.requests.filter(e => e.status_id == activeRequestsId && e.request_type_id === 1).length > 0;
        self.selectedSystemUserGroups[el.code] = {};
        self.selectedSystemUserGroups[el.code].value = !!(el.group_users || hasActiveRequests) || this.activeGroups.includes(el.code);
        self.selectedSystemUserGroups[el.code].isDisabled = !!(hasActiveRequests) || self.selectedSystemUserGroups[el.code].value;
        if (self.selectedSystemUserGroups[el.code].value) {
          self.activeGroups.push(el.code);
        }
      });
      this.$refs.editUserGroups.show();
    },
    removeItem (system, group) {
      const el = { system: system, group: group, user: this.user };
      this.$refs.msgBoxApproveRemoveGroup.show(
        el,
        this.$t('ebgsystem.removeGroupTitle'),
        this.$t('ebgsystem.removeGroupMessage', { system: system.title, group: group.code, username: (this.user.name + ' ' + this.user.surname) })
      )
    },
    removeItemApproved (item) {
      const reqData = { user: item.user.api_id, groups: [], autoapprove: false };
      reqData.groups.push({ group: item.group.code, delete: true });
      this.changeSystemPermissions(item.system.id, reqData);
    },
    editSystemGroups () {
      const reqData = { user: this.user.api_id, groups: [] };
      for (const [groupCode, params] of Object.entries(this.selectedSystemUserGroups)) {
        if (!params.isDisabled && params.value) {
          reqData.groups.push({ group: groupCode, delete: !params.value })
        }
      }
      this.changeSystemPermissions(this.selectedSystem.id, reqData);
    },
    changeSystemPermissions (systemId, reqData) {
      this.updatingUserGroups = true;
      this.ApiRequest.request('ad-groups/ebg-systems/' + systemId + '/change-permissions', this.ApiRequest.REQUEST_POST, reqData, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else if (response.data) {
          this.user.ad_group_permissions = response.data;
          this.$refs.editUserGroups.hide();
          if (response.data.groups_added && response.data.groups_added.length > 0) {
            this.$store.commit('toastAdd', {
              context: 'success',
              message: this.$t('ebgsystem.permissions-requested')
            });
            response.data.groups_added.forEach((group) => {
              this.tableItems.find(el => el.id == group.system_id)?.groups.push(group);
              this.activeGroups.push(group.code);
            });
          }
        }
        this.updatingUserGroups = false;
      });
    },
    viewList (system) {
      this.selectedSystem = system;
      this.$refs.modalUsers.show();
    }
  },
  watch: {
    user: {
      immediate: true,
      handler (user) {
        if (user && user.api_id) {
          this.getTableData();
        }
      }
    }
  },
  mounted () {
    if (this.user && this.user.api_id) {
      this.getTableData();
    }
  }

}
